module.exports = __webpack_public_path__ + "img/brushes-cn-3.dd8300b.jpg";